export const RiderTypes = {
    Unknown: 'unknown',
    Passengers: 'passengers',
    Motorcycles: 'mc',
    Cars: 'cars',
    Cars8m: 'cars8m',
    Cars10m: 'cars10m',
    Cars12m: 'cars12m',
    Cars14m: 'cars14m',
    Cars17m: 'cars17m',
    Cars19m: 'cars19m',
    Cars22m: 'cars22m',
    CarsMin22m: 'carsMin22m',
    CarsLeftBehind: 'carsLeftBehind'
};

const riderTypes: string[] = Object.keys(RiderTypes).map(x => RiderTypes[x]);

export type RiderType = (typeof riderTypes)[number];
